import { useRecoilValue } from 'recoil';
import * as THREE from 'three';
import { projectionModeState } from '../state/viewModeAtoms';

interface Params {
  perspCam: THREE.PerspectiveCamera | null;
  orthoCam: THREE.OrthographicCamera | null;
}

export const useActiveCamera = ({
  perspCam,
  orthoCam,
}: Params): THREE.PerspectiveCamera | THREE.OrthographicCamera | null => {
  const mode = useRecoilValue(projectionModeState);
  if (mode === 'orthographic') {
    return orthoCam ?? perspCam;
  }
  return perspCam ?? orthoCam;
};
